import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Fetches the interest record for a parent and professional (by ID) for a specific searched role.
 * @param {string} parentId
 * @param {string} professionalId
 * @param {string} searchedRole
 * @returns {Promise<Object|null>} The interest record, or null if not found.
 */
export async function fetchInterestStatus(parentId, professionalId, searchedRole) {
  const q = query(
    collection(db, 'interests'),
    where('parentId', '==', parentId),
    where('professionalId', '==', professionalId),
    where('searchedRole', '==', searchedRole)
  );
  const querySnapshot = await getDocs(q);
  if (!querySnapshot.empty) {
    return { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
  }
  return null;
}
